import axiosInstance from './apiConfig';

export const getAllProperties = async (search?: string) => {
  try {
    const response = await axiosInstance.get('/property/getAll', {
      params: {
        ...(search && search.length > 0 ? { search } : {}),
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      `Failed to fetch properties ${error.response?.data?.error}`,
    );
  }
};

export const getPropertiesByOrganizationId = async (
  organizationId: string,
  search?: string,
) => {
  try {
    const response = await axiosInstance.get(`/property/getByOrganizationId`, {
      params: {
        organizationId,
        search,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      `Failed to fetch properties ${error.response?.data?.error}`,
    );
  }
};

export const addNewProperty = async data => {
  try {
    const response = await axiosInstance.post('/property/add', data);

    return response.data;
  } catch (error) {
    throw new Error(`add property failed ${error.response?.data?.error}`);
  }
};

export const editProperty = async (id: number, data) => {
  try {
    const response = await axiosInstance.put(`/property/update?id=${id}`, data);

    return response.data;
  } catch (error) {
    throw new Error(`edit property failed ${error.response?.data?.error}`);
  }
};

export const removeProperty = async (propertyId: string) => {
  try {
    const response = await axiosInstance.delete(
      '/property/delete?id=' + propertyId,
    );

    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getPropertyById = async (id: string) => {
  try {
    const response = await axiosInstance.get(`/property/getById?id=${id}`);

    return response.data;
  } catch (error) {
    throw new Error(
      `fetch property by id failed ${error.response?.data?.error}`,
    );
  }
};

export const assignRentCollector = async (
  propertyId: string,
  rentCollectorId: string,
) => {
  try {
    const response = await axiosInstance.post('/property/rent-collector', {
      propertyId,
      rentCollectorId,
    });
    return response.data;
  } catch (error) {
    throw new Error(
      `Failed to assign rent collector ${error.response?.data?.error}`,
    );
  }
};

export const getSubPropertiesByPropertyId = async (
  parentPropertyId: string,
  search?: string,
) => {
  try {
    const response = await axiosInstance.get(`/property/getByParentId`, {
      params: {
        parentPropertyId,
        ...(search && search.length > 0 ? { search } : {}),
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      `Failed to fetch sub properties ${error.response?.data?.error}`,
    );
  }
};

// Fetch all rent collectors assigned to a specific property
export const getRentCollectorsByPropertyId = async (propertyId: string) => {
  try {
    const response = await axiosInstance.get('/property/rent-collectors', {
      params: { propertyId },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      `Failed to fetch rent collectors ${error.response?.data?.error}`,
    );
  }
};

// Remove a rent collector from property
export const removeRentCollector = async (
  propertyId: string,
  rentCollectorId: string,
) => {
  try {
    const response = await axiosInstance.delete('/property/rent-collector', {
      params: { propertyId, rentCollectorId },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      `Failed to remove rent collector ${error.response?.data?.error}`,
    );
  }
};

export const getPropertiesByLandId = async (landId: string) => {
  try {
    const response = await axiosInstance.get(`/property/getByLandId`, {
      params: { landId },
    });
    return response.data;
  } catch (error: any) {
    throw new Error(
      `Failed to fetch properties by landId ${error.response?.data?.error || error}`,
    );
  }
};

export const exportProperties = async (
  organizationId: number,
  landId?: number,
): Promise<Blob> => {
  try {
    let url = `/property/export?organizationId=${organizationId}`;

    if (landId) {
      url += `&landId=${landId}`;
    }

    const response = await axiosInstance.get(url, {
      responseType: 'blob',
    });

    return response.data;
  } catch (error) {
    throw new Error(`export properties failed ${error}`);
  }
};

export const uploadProperties = async (file: File) => {
  const data = new FormData();
  data.append('file', file);

  try {
    const response = await axiosInstance.post('/property/upload', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error: any) {
    throw error?.response?.data || error;
  }
};
